export const cepMask = (value) => {
  if (value) {
    return value
      .replace(/\D/g, '') // não deixa ser digitado nenhuma letra
      .replace(/(\d{5})(\d)/, '$1-$2')
      .substring(0, 9);
  }
};
